<script setup>
import TableFilter from "./filters/TableFilter";
import Pagination from "./pagination/Pagination";
import NoDataTable from "./NoDataTable";
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";

const props = defineProps({
        showTableFilter: {
            type: Boolean,
            default: true
        },
        showPagination: {
            type: Boolean,
            default: true
        },
        paginationData: {
            type: Object,
            default: {}
        },
        filterableFields: {
            type: Object
        },
        loadingData: {
            type: Boolean,
            default: false
        }
})

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const layout = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout);
const layoutStyle = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style);
const corners = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_corners);

const getFlexClassesBasedOnLayoutOptions = () => {
    const classes = [];

    if (layout === 'one') {
        classes.push('sm:h-24', 'h-auto');
    }

    if (layoutStyle === 'none') {
        classes.push('mb-4', corners);
        if (layout !== 'one') {
            classes.push('px-8', 'py-8', 'bg-gray-600', 'bg-opacity-5');
        }
    } else {
        classes.push('border-b', 'border-gray-200', 'border-opacity-75', 'px-6', 'sm:px-8');
    }

    return classes.join(' ');
};
</script>
<template>

    <div class="flex items-center py-6"
         :class="getFlexClassesBasedOnLayoutOptions()">
        <table-filter
            v-if="showTableFilter"
            :filter-list="filterableFields"
        />
    </div>

    <div class="flex flex-col">
        <div class="overflow-x-auto">
            <slot v-if="paginationData.data?.length > 0" />
            <no-data-table v-else-if="!loadingData && paginationData.data?.length === 0" />
            <pagination
                v-if="showPagination && paginationData.data?.length !== 0"
                :pagination="paginationData"
            />
        </div>
    </div>
</template>
